<template>
    <div class="aup-base-linebox position-relative" :class="{'aup-base-linebox--warning': hasError}">
		<p class="aup-base-linebox__label t-micro text-uppercase bg-white px-2"  v-if="label">error:call:48</p>
        <slot/>
    </div>
</template>
<script>
	export default {
		name: "BaseLineBox",
		props: {
			label: {
				type: String,
				default: ""
			},
			hasError: {
				type: Boolean,
				default: false,
			}
		}
    };
</script>

<style lang="scss">
    @import "../../assets/scss/all";
    .aup-base-linebox {
        border-style: solid;
        border-color: $gray-400;
		border-width: 1px;

		&__label {
			position: absolute;
			top: 0;
			left: 15px;
			transform: translateY(-50%)

		}

		&--warning {
			border-color: $danger;

			.aup-base-linebox__label {
				color: $danger;
			}
		}
    }
</style>
